const getHbbTvVersion = () => {
    try {
        const userAgent = navigator.userAgent;
        const version = userAgent.match(/HbbTV\/\d\.(\d).(\d)/g)[0];
        const number = version.split('/')[1];
        switch (number) {
            case '1.1.1':
                return '1.0';
            case '1.2.1':
                return '1.5';
            case '1.3.1':
                return '2.0';
            case '1.4.1':
                return '2.0.1';
            case '1.5.1':
                return '2.0.2';
            default:
                return null;
        }
    } catch (e) {
        return null;
    }

};

export { getHbbTvVersion }